import { render, staticRenderFns } from "./ClaimTypeQuestion.vue?vue&type=template&id=4d037eea&scoped=true"
import script from "./ClaimTypeQuestion.vue?vue&type=script&lang=ts"
export * from "./ClaimTypeQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d037eea",
  null
  
)

export default component.exports